export enum SlideElementPosition {
  Left = 'left',
  LeftNarrow = 'left-narrow',
  LeftWide = 'left-wide',
  Center = 'center',
  BottomLeft = 'bottom-left',
  RightNarrow = 'right-narrow',
  RightWide = 'right-wide',
  Right = 'right',
}
// Default center

export default SlideElementPosition